"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompleteFolderContext = exports.IsChooseFolderContext = void 0;
function IsChooseFolderContext(context) {
    return context.Type === "OpenFolder" || context.Type === "MoveToFolder";
}
exports.IsChooseFolderContext = IsChooseFolderContext;
function CompleteFolderContext(context, onSubmit) {
    return Object.assign(Object.assign({}, context), { OnSubmit: onSubmit });
}
exports.CompleteFolderContext = CompleteFolderContext;
//# sourceMappingURL=file-browser-context.js.map